//#region Imports and Global Definitions
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { StyleSheet, View, SafeAreaView, Platform, useWindowDimensions, FlatList } from 'react-native';
import { useTheme } from '@react-navigation/native';
import { createCommonStyles } from '../../../../styles/commonStyles';
import CustomLabel from '../../../../components/CustomLabel/CustomLabel';
import CustomInput from '../../../../components/CustomInput';
import CustomButton from '../../../../components/CustomButton';
import { ActivityIndicator, Card } from 'react-native-paper';
import { showMessage } from "react-native-flash-message";
import CustomDropDown from '../../../../components/CustomDropDown/CustomDropdown'
import { useCompany } from '../../../../hooks/useCompany';
var _ = require('lodash');

// * Language
import { useTranslation } from 'react-i18next';
import { useSettingsContext } from '../../../../hooks/useSettingsContext';
import { useTableHelper } from '../../../../hooks/useTableHelper';


const DepartmentListView = React.memo(({ item, index, handleEditPress, employees,
    handleDeleteLocation, styles, d365, phasecodes, t, duplicates, hasChildren
}) => {
    let errorMark = false;
    let errorAttr = '';

    duplicates.forEach(duplicate => {
        if (duplicate.attrVal.includes(item[duplicate.attribute])) {
            errorMark = true;
            errorAttr = duplicate.attrVal;
        }
    });

    const [showAdditionalLocationInfo, setAdditionalLocationInfo] = useState(false);
    useEffect(() => {
        //TODO
    }, [showAdditionalLocationInfo])
    const onShowAdditionalLocationInfoPress = (item) => {
        setAdditionalLocationInfo(!showAdditionalLocationInfo)
    }
    return (
        <View>
            <SafeAreaView>
                <SafeAreaView>
                    <SafeAreaView
                        style={styles.row}>
                        {/* //* Always Visible */}
                        <SafeAreaView
                            style={styles.itemrow}>
                            <CustomLabel
                                value={t('common:department')}
                                type='SUBTITLENOFLEX' />
                            <CustomInput
                                value={item.dept}
                                setValue={(e) => handleEditPress(index, item, 'dept', e)}
                                maxLen={5}
                                type={errorMark && errorAttr === item.dept ? "MISSING_DEPARTMENT_CODE" : "MAININPUT"}
                            />
                        </SafeAreaView>
                        <SafeAreaView
                            style={styles.itemrow}>
                            <CustomLabel
                                value={t('common:description')}
                                type='SUBTITLENOFLEX' />
                            <CustomInput
                                value={item.description}
                                setValue={(e) => handleEditPress(index, item, 'description', e)}
                                maxLen={50}
                                type="MAININPUT"
                            />
                        </SafeAreaView>
                        <SafeAreaView>
                            <CustomButton
                                iconName={!showAdditionalLocationInfo ? 'chevron-forward-outline' : 'chevron-down-outline'}
                                onPress={() => {
                                    onShowAdditionalLocationInfoPress(item, index)
                                }}
                                text={t('common:additionalInfos')}
                                show='PART'
                                type='PART'
                                textTop='0'
                                sz={30} />
                        </SafeAreaView>
                        {!hasChildren[item.deptID] &&
                            <SafeAreaView style={styles.justMargin}>
                                <CustomButton
                                    iconName='trash-outline'
                                    onPress={() => {
                                        handleDeleteLocation(item, index, 'deptID')
                                    }}
                                    show='PART'
                                    type='PART'
                                    textTop='2'
                                    sz={30} />
                            </SafeAreaView>
                        }
                    </SafeAreaView>

                    {showAdditionalLocationInfo &&
                        <SafeAreaView style={styles.row}>
                            <SafeAreaView
                                style={styles.item}>
                                <CustomLabel
                                    value={t('common:hod')}
                                    type='SUBTITLE' />
                                <CustomDropDown
                                    defValue={item?.hod}
                                    options={employees}
                                    value={item?.hod}
                                    type="DEPARTMENTS"
                                    setValue={(e) => handleEditPress(index, item, 'hod', e)}
                                    label={"Select"}
                                />
                            </SafeAreaView>
                            <SafeAreaView
                                style={styles.item}>
                                <CustomLabel
                                    value={t('common:functionCode')}
                                    type='SUBTITLE' />
                                <CustomInput
                                    value={item.functionCode}
                                    setValue={(e) => handleEditPress(index, item, 'functionCode', e)}
                                    maxLen={50}
                                    type="MAININPUT"
                                />
                            </SafeAreaView>
                            <SafeAreaView
                                style={styles.item}>
                                <CustomLabel
                                    value={t('common:functionDescription')}
                                    type='SUBTITLE' />
                                <CustomInput
                                    value={item.functionDescription}
                                    // defaultValue={item.functionDescription}
                                    setValue={(e) => handleEditPress(index, item, 'functionDescription', e)}
                                    maxLen={200}
                                    type="MAININPUT"
                                />
                            </SafeAreaView>
                            <SafeAreaView
                                style={styles.item}>
                                <CustomLabel
                                    value={t('common:chargesCode')}
                                    type='SUBTITLE' />
                                <CustomDropDown
                                    defValue={item?.chargesCode}
                                    options={phasecodes}
                                    value={item?.chargesCode}
                                    type="DEPARTMENTS"
                                    setValue={(e) => handleEditPress(index, item, 'chargesCode', e)}
                                    label={"Select"}
                                />
                            </SafeAreaView>
                            <SafeAreaView
                                style={styles.item}>
                                <CustomLabel
                                    value={t('common:regionalCode')}
                                    type='SUBTITLE' />
                                <CustomInput
                                    value={item.regionalCode}
                                    // defaultValue={item.regionalCode}
                                    setValue={(e) => handleEditPress(index, item, 'regionalCode', e)}
                                    maxLen={5}
                                    type="MAININPUT"
                                />
                            </SafeAreaView>
                            {d365 &&
                                <>
                                    <SafeAreaView
                                        style={styles.item}>
                                        <CustomLabel
                                            value={t('common:regionalCode')}
                                            type='SUBTITLE' />

                                        <CustomInput
                                            value={item.d365Code}
                                            setValue={(e) => handleEditPress(index, item, 'd365Code', e)}
                                            maxLen={50}
                                            type="MAININPUT"
                                        />
                                    </SafeAreaView>
                                    <SafeAreaView
                                        style={styles.item}>
                                        <CustomLabel
                                            value={t('common:d365FDCode')}
                                            type='SUBTITLE' />
                                        <CustomInput
                                            value={item.d365FDCode}
                                            setValue={(e) => handleEditPress(index, item, 'd365FDCode', e)}
                                            maxLen={50}
                                            type="MAININPUT"
                                        />
                                    </SafeAreaView>
                                </>
                            }
                        </SafeAreaView>
                    }
                </SafeAreaView>
            </SafeAreaView>
        </View >
    )
})

const HRAdminDepartmentsScreen = ({ props }) => {

    //#region Const Definitions
    const { rowEdit, rowDelete, rowAdd, handleCancelChanges, hasDuplicates } = useTableHelper();
    const { getDepartmentsData, getPhaseCodes, insertDepartment, deleteDepartment, updateDepartment, getL4 } = useCompany();
    const isPlatformWeb = (Platform.OS === 'web' && width > 992 ? false : true);
    const { width, height } = useWindowDimensions();
    const { colors } = useTheme();
    const styles = makeStyles(colors, width, height, isPlatformWeb);
    const common = createCommonStyles(colors);
    const { d365 } = useSettingsContext();
    const [isLoading, setIsLoading] = useState(true);
    const [departmentData, setDepartmentsData] = useState([]);
    const [originalData, setOriginalData] = useState([]);
    const [refreshAfterSave, setRefreshAfterSave] = useState(false);
    const [employees, setEmployees] = useState([]);
    const [insertData, setInsertData] = useState([]);
    const [deletedItems, setDeletedItems] = useState([])
    const [duplicates, setDuplicates] = useState([])
    const [hasChildren, setHasChildren] = useState([]);
    const [phaseCodes, setPhaseCodes] = useState([]);
    const ref = useRef(null); // for automatic scrolling purposes
    //#endregion

    //#region Language
    const { t, i18n } = useTranslation();
    //#endregion

    //#region UseEffect
    useEffect(() => {
        setIsLoading(true);
        getDepartmentsData({ props }).then((arr) => {
            setDepartmentsData(arr);
            setOriginalData([...arr])
            props.setChanges({});

            setEmployees(props.companyEmployees);

            getPhaseCodes(arr, { props }).then((res) => {
                let data = [];
                res.forEach((obj) => {
                    data.push({ label: obj.phasecode, value: obj.id });
                });
                setPhaseCodes([...data])

                getL4({ props }, arr).then((res) => {
                    const matchedDeptIDs = arr.reduce((acc, dept1) => {
                        const match = res.data.some(dept2 => dept2.dept === dept1.dept);
                        acc[dept1.deptID] = match ? dept1.dept : undefined;
                        return acc;
                    }, {});
                    setHasChildren(matchedDeptIDs)
                })
                setIsLoading(false);
            })
        })
        setRefreshAfterSave(false);
    }, [props.selectedCompany, props.selectedServCode, refreshAfterSave])
    //#endregion

    //#region Helpers

    const getSelectedHeadIDs = (arr, employees) => {
        let selectedIDs = arr.map(obj => obj.hod);
        const selectedEmployees = selectedIDs.reduce((acc, id, index) => {
            const employee = employees.find(employee => employee.value === id);
            acc[index] = { value: employee ? employee.value : -1 };
            return acc;
        }, {});
        return selectedEmployees;
    }

    const validateInput = () => {
        let ret = [true, t('common:validationSuccess')]
        departmentData.forEach((itr) => {
            if (itr.dept === '' || !itr.hasOwnProperty('dept'))
                ret = [false, t('common:mandatoryCodeNotGivenDepartments')];
            if (itr.description === '')
                ret = [false, t('common:descEmpty')]
        })
        return (ret)
    }

    const removeFromChangesAfterSave = () => {
        props.setChanges([])
        setDeletedItems([])
    }

    //#endregion

    //#region Handlers

    const handleEditPress = useCallback((idx, item, key, value) => {
        if (item[key] === value) return;
        rowEdit(idx, item, key, value, props.changes, props.setChanges, departmentData, setDepartmentsData)
        props.checkIfUnsavedChangesInDepartments(true);
    }, [])

    const handleSave = async () => {
        let newPromises = [];
        let deleteSucc = true;
        let insertSucc = true;
        let updateSucc = true;
        let valid = true;

        // * Do not save if Changes table is empty
        if (Object.entries(props.changes).length == 0 && deletedItems.length == 0) {
            showMessage({
                message: t('common:noChanges'),
                type: "danger",
                duration: 3000,
            })
            return
        }

        const attributesToIgnore = [
            'description', 'hod', 'functionCode', 'functionDescription',
            'chargesCode', 'regionalCode', 'd365Code', 'd365FDCode',
            'oldDepartmentID', 'deptID'
        ];

        if (departmentData.length > 0)
            Object.keys(departmentData[0]).forEach(key => {
                //* Ignore Keys that we know can be duplicated 
                if (!attributesToIgnore.includes(key)) {
                    if (hasDuplicates(departmentData, key, setDuplicates)) {
                        showMessage({
                            message: t('common:duplicates'),
                            type: "danger",
                            duration: 3000,
                        })
                        // * Abort Save if this is triggered.
                        valid = false;
                    }
                }
            });

        if (!valid)
            return null;

        let valRet = validateInput();
        if (!valRet[0]) {
            showMessage({
                message: valRet[1],
                type: "danger",
                duration: 3000,
            })
            return;
        }

        let dataForInsert = [];
        let dataForUpdate = [];

        Object.entries(departmentData).forEach(([key, obj]) => {
            if (insertData.includes(obj.deptID)) {
                dataForInsert.push(obj);
            } else {
                dataForUpdate.push(obj);
            }
        });

        if (Object.keys(dataForUpdate).length > 0) {
            newPromises.push(updateDepartment({ props }, dataForUpdate)
                .then((res) => {
                    if (!res) updateSucc = false;
                    removeFromChangesAfterSave()
                })
                .catch(() => { }));
        }
        if (Object.keys(dataForInsert).length > 0) {
            newPromises.push(insertDepartment({ props }, dataForInsert)
                .then((res) => {
                    if (!res) insertSucc = false;
                    removeFromChangesAfterSave()
                })
                .catch(() => { }));
        }
        if (deletedItems.length > 0) {
            newPromises.push(deleteDepartment(deletedItems).then((res) => {
                if (!res) deleteSucc = false;
                removeFromChangesAfterSave()
            })
                .catch(() => { }));
        }

        try {
            await Promise.all(newPromises).then(() => { // when all the callee async functions return, show message based on result
                if (!insertSucc || !deleteSucc || !updateSucc) {
                    if ((!insertSucc || !updateSucc) && deleteSucc) {
                        showMessage({
                            message: t('common:primaryKeyViolation'),
                            type: "danger",
                            duration: 3000,
                        })
                    }
                    else if (!deleteSucc) {
                        showMessage({
                            message: t('common:deptsIsUsedByEMPLDEPTS'),
                            type: "danger",
                            duration: 9000,
                        })
                        setRefreshAfterSave(true); // fetch updates from db
                    }
                    else
                        showMessage({
                            message: t('common:issueMessage'),
                            type: "error",
                            duration: 3000,
                        })
                }
                else if (insertSucc && deleteSucc && updateSucc) {
                    showMessage({
                        message: t('common:allOperationsSuccMess'),
                        type: "success",
                        duration: 3000,
                    })
                    setDuplicates([]);
                    setIsLoading(true);
                    setRefreshAfterSave(true); // fetch updates from db
                    props.checkIfUnsavedChangesInDepartments(false);
                }
            });
        } catch (error) {
            setDuplicates([]);
            setIsLoading(true);
            setRefreshAfterSave(true);
        }
    }

    const handleDelete = (item, index, attribute) => {
        rowDelete(item, index, attribute, props.changes, props.setChanges, departmentData, setDepartmentsData, setDeletedItems, ref)
    }

    const handleAddNewDepartment = () => {
        let temp = [...departmentData];
        if (departmentData.length === 0)
            temp = {
                dept: "",
                description: "",
                hod: "",
                functionCode: "",
                functionDescription: "",
                chargesCode: "",
                regionalCode: "",
                d365Code: "",
                d365FDCode: "",
                oldDepartmentID: "",
                deptID: ""
            }
        rowAdd(temp, setDepartmentsData, exceptions = ['deptID'], [], ref, t, [], [], undefined, undefined, insertData, setInsertData, id = 'deptID');
    }

    //#endregion

    //#region Components
    const renderData = useCallback((item, index) => {
        return (
            <Card
                style={[common.cardstyle]} >
                <Card.Content>
                    <DepartmentListView item={item} index={index}
                        handleEditPress={handleEditPress}
                        employees={employees}
                        handleDeleteLocation={handleDelete}
                        duplicates={duplicates}
                        hasChildren={hasChildren}
                        phasecodes={phaseCodes}
                        styles={styles}
                        d365={d365}
                        t={t}
                    />
                </Card.Content>
            </Card>
        )
    }, [departmentData, duplicates, hasChildren]);

    //#endregion

    //#region Loading
    if (isLoading) {
        <View style={styles.loader}>
            <ActivityIndicator animating={true} color={colors.blue} />
        </View>
    }
    //#endregion

    return (
        <SafeAreaView style={styles.mainView}>
            <SafeAreaView style={styles.rowView}>
                <SafeAreaView style={[styles.subMain]}>
                    <View style={[styles.buttons, styles.functionalityButtons]}>
                        {props.selectedServLevel !== "" &&
                            (
                                <>
                                    <CustomButton
                                        text={t('common:createNewFunction')}
                                        onPress={() => handleAddNewDepartment()}
                                        type='BUTTON_ADD'
                                        textTop='0'
                                        sz={15}
                                    />
                                    {(Object.keys(props.changes).length > 0 ||
                                        departmentData.length > 0 ||
                                        deletedItems.length > 0) &&
                                        <CustomButton
                                            text={t('common:saveFunction')}
                                            onPress={() => handleSave()}
                                            type='BUTTON_SAVE'
                                            textTop='0'
                                            sz={15}
                                            isGradient={true}
                                        />
                                    }
                                    <CustomButton
                                        text={t('common:cancel')}
                                        onPress={() => {
                                            handleCancelChanges(setDepartmentsData, originalData, setDeletedItems, props.setChanges, setDuplicates);
                                            props.checkIfUnsavedChangesInDepartments(false);
                                        }}
                                        type="BUTTON_CANCEL"
                                        sz={15}
                                    />
                                </>
                            )}
                    </View>
                    <SafeAreaView style={common.divider} />
                    {props.selectedCompany &&
                        <View style={styles.innerView}>
                            <View style={styles.departmentsView}>
                                <FlatList
                                    style={styles.departmentsFlatList}
                                    data={departmentData}
                                    keyExtractor={(item, index) => `${item.location}-${index}`}
                                    renderItem={({ item, index }) =>
                                        renderData(item, index)
                                    }
                                    scrollEnabled={true}
                                    refreshing={isLoading}
                                    ref={ref}
                                    initialNumToRender={4}
                                    ListEmptyComponent={
                                        isLoading ?
                                            <ActivityIndicator animating={true} color={colors.blue} />
                                            :
                                            <CustomLabel
                                                value={t("common:deptsNoDataPreview")}
                                                type="NO_FUNCTIONS"
                                            />
                                    }
                                />
                            </View>

                        </View>
                    }
                </SafeAreaView>
            </SafeAreaView >
        </SafeAreaView >
    )
};

//#region Styles
const makeStyles = (colors, width) => StyleSheet.create({
    mainView: {
        flex: 1,
        margin: 10,
    },
    subMain: {
        borderRadius: 35,
        elevation: (Platform.OS === 'web' && width > 992 ? 3 : 0),
        shadowColor: colors.card_line,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.1,
        width: '100%'
    },
    rowView: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'center'
    },
    row: {
        flex: 1,
        margin: 10,
        flexDirection: "row",
        alignItems: 'center',
    },
    item: {
        flex: 1,
    },
    flatlistHeader: {
        marginRight: '4%',
    },
    functionalityButtons: {
        justifyContent: 'flex-end',
        marginVertical: 10,
    },
    departmentsFlatList: {
        height: '85%',
    },
    innerView: {
        flex: 1,
        marginVertical: 10,
    },
    buttons: {
        flexDirection: 'row',
        justifyContent: 'flex-end',
        alignSelf: 'flex-end',
    },
    loader: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '4%'
    },
    departmentsView: {
        flexDirection: 'row',
        height: '100%',
    },
    itemrow: {
        flex: 1,
        flexDirection: 'row',
    },
});


//#endregion
export default HRAdminDepartmentsScreen;